import React, { useState, useRef } from 'react';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { Navigation, Scrollbar, Pagination, EffectFade } from 'swiper';
import { IconA1, IconA2, IconA3, IconA4, IconB1, IconB2, IconB3, IconB4, IconC1, IconC2, IconC3, IconC4 } from './icons';
import { useLang } from '@/i18n';
const SenceCardC = () => {
    const { t } = useLang('Delta3AirStation.SenceCardC');
    const swiperRef = useRef<any>(null);

    const contentList: any = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761616777915/sence-c-1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761616777915/sence-c-1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761655007580/Frame%201612707467.jpg',
            iconList: [
                {
                    icon: <IconA1 />,
                    name: 'USB-C充電式ライト（10W）',
                    time: '90',
                    unit: '時間',
                },
                {
                    icon: <IconA2 />,
                    name: 'ポータブル冷蔵庫（55W）',
                    time: '15~140',
                    unit: '時間*',
                },
                {
                    icon: <IconA3 />,
                    name: '炊飯器（500W）',
                    time: '1.8',
                    unit: '時間',
                },
                {
                    icon: <IconA4 />,
                    name: '小型ドライヤー（700W）',
                    time: '1.2',
                    unit: '時間',
                },
            ],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761616778287/sence-c-2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761616778287/sence-c-2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761655007116/Frame%201612707467%20(1).jpg',
            iconList: [
                {
                    icon: <IconB1 />,
                    name: 'ホットプレート（800W）',
                    time: '1',
                    unit: '時間',
                },
                {
                    icon: <IconB2 />,
                    name: '電気ケトル（600W）',
                    time: '1.4',
                    unit: '時間',
                },
                {
                    icon: <IconB3 />,
                    name: 'スマホ（11Wh）',
                    time: '74',
                    unit: '回分',
                },
                {
                    icon: <IconB4 />,
                    name: 'サンドイッチメーカー（500W）',
                    time: '1.6',
                    unit: '時間',
                },
            ],
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761616778079/sence-c-3-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761616778079/sence-c-3-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761655007317/Frame%201612707467%20(2).jpg',
            iconList: [
                {
                    icon: <IconC1 />,
                    name: 'テレビ（110W）',
                    time: '8',
                    unit: '時間',
                },
                {
                    icon: <IconC2 />,
                    name: '電気毛布（60W）',
                    time: '15',
                    unit: '時間',
                },
                {
                    icon: <IconC3 />,
                    name: '冷蔵庫（年間消費電力量約200Wh）',
                    time: '8~42',
                    unit: '時間',
                },
                {
                    icon: <IconC4 />,
                    name: '扇風機（50W）',
                    time: '16',
                    unit: '時間',
                },
            ],
        },
    ];

    const items = [
        {
            tabLabel: t('tab_1'),
            tabValue: 'a',
        },
        {
            tabLabel: t('tab_2'),
            tabValue: 'b',
        },
        {
            tabLabel: t('tab_3'),
            tabValue: 'c',
        },
    ];

    const [activeItem, setActiveItem] = useState<any>(contentList[0]);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(contentList[index]);
        swiperRef.current.slideToLoop(index);
        setActiveTabIndex(index);
    };

    const onSlideChange = ({ activeIndex, realIndex }: any) => {
        setActiveTabIndex(realIndex);
    };

    return (
        <section className={`${styles.SenceCardC} range5 GtmModuleData-section`} id="List-sence-E" data-section-id="SenceCardC">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="subtitle">{t('subtitle')}</div>
            </div>
            <div className="content-box">
                <div className="sence-swiper">
                    <Swiper
                        modules={[Navigation, Pagination, EffectFade]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        loop={true}
                        pagination
                        effect={'fade'}
                        speed={800}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        onSlideChange={onSlideChange}
                    >
                        {contentList.map((item: any, index: number) => (
                            <SwiperSlide key={index} className="swiper-slide">
                                <div className="used-sence-card">
                                    <div className="used-img">
                                        <EcoImg className="swiper-img" pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                                    </div>
                                    <div className="used-desc-box">
                                        {item.iconList.map((v: any, i: number) => (
                                            <div className="used-icon" key={`${i}`}>
                                                <div className="item-icon">{v.icon}</div>
                                                <div className="item-name">{v.name}</div>
                                                <div className="item-used-desc">
                                                    <span className="used-time">{v.time}</span>
                                                    <span className="used-unit">{v.unit}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className={`content-tab`}>
                    <EcoTab onChange={toggleItemHandle} items={items} theme={'white'} activeIndex={activeTabIndex} />
                </div>
                <div className="tips">
                    {t.rich('tips', {
                        link1: (str: string) => (
                            <a className="link1" href="https://www.ecoflow.com/jp/glacier-classic-portable-refrigerator/specs">
                                {str}
                            </a>
                        ),
                    })}
                </div>
            </div>
        </section>
    );
};

export default SenceCardC;
